
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import styles from '../core-exchange.module.scss';
export const metadata = {
  toc: true,
  subnav: true,
  title: 'Production access',
  layout: 'guide',
  description: 'Request production access, run stealth testing, and launch your integration',
  parentTocLevel: 2,
  childTocLevel: 3,
  secondLevelToc: true,
  alwaysExpand: true
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className={styles.page}>
      <Header title='Production access' subtitle={metadata.description} mdxType="Header" />
      <h2 {...{
        "id": "requesting-production-access"
      }}>{`Requesting production access`}</h2>
      <p>{`Once all required endpoints pass validation, a `}<strong parentName="p">{`Request Production Access`}</strong>{` button becomes available in the Dashboard.`}</p>
      <p>{`After you submit a production request, Plaid will:`}</p>
      <ul>
        <li parentName="ul">{`Perform a final configuration review`}</li>
        <li parentName="ul">{`Recheck your OAuth and data flows`}</li>
        <li parentName="ul">{`Confirm your institution branding`}</li>
        <li parentName="ul">{`Coordinate production timing with your team`}</li>
      </ul>
      <p>{`Your integration will not be visible to end users until your team confirms the launch timing.`}</p>
      <p>{`For platform integrations, you do not need to request production access for each institution separately. Submit each new institution as a new integration in the Dashboard, and Plaid will review and approve it before enabling production traffic.`}</p>
      <h2 {...{
        "id": "stealth-testing-optional"
      }}>{`Stealth testing (optional)`}</h2>
      <p>{`Stealth testing allows you to run production traffic under a temporary institution name that does not appear in Plaid Link search results. This allows you to:`}</p>
      <ul>
        <li parentName="ul">{`Test your integration through real third-party applications`}</li>
        <li parentName="ul">{`Send limited traffic through production infrastructure`}</li>
        <li parentName="ul">{`Run friends-and-family or internal testing`}</li>
        <li parentName="ul">{`Identify edge cases not present in pre-production`}</li>
      </ul>
      <p>{`Once testing is successful, update the institution name and branding to make the integration discoverable in Plaid Link.`}</p>
      <h2 {...{
        "id": "launching-and-discoverability"
      }}>{`Launching and discoverability`}</h2>
      <p>{`After production access is enabled, your institution appears in Plaid Link search results for applications that use the products you support (e.g., Auth, Transactions, Identity) and the account types you offer (e.g., checking, savings, credit).`}</p>
      <h2 {...{
        "id": "pre-launch-checklist"
      }}>{`Pre-launch checklist`}</h2>
      <p>{`Complete before going live:`}</p>
      <h3 {...{
        "id": "configuration"
      }}>{`Configuration`}</h3>
      <ul>
        <li parentName="ul">{`Deploy your OAuth server to your production environment`}</li>
        <li parentName="ul">{`Verify your discovery endpoint is accessible`}</li>
        <li parentName="ul">{`Publish your JWKS endpoint and verify it is accessible`}</li>
        <li parentName="ul">{`Issue production credentials to Plaid`}</li>
        <li parentName="ul">{`Configure mTLS certificates (if applicable)`}</li>
        <li parentName="ul">{`Confirm your organization name, logo, and URL`}</li>
      </ul>
      <h3 {...{
        "id": "testing"
      }}>{`Testing`}</h3>
      <ul>
        <li parentName="ul">{`Pass validation for all required endpoints`}</li>
        <li parentName="ul">{`Verify error handling for common failure cases`}</li>
        <li parentName="ul">{`Test token expiration and refresh flows`}</li>
      </ul>
      <h3 {...{
        "id": "monitoring"
      }}>{`Monitoring`}</h3>
      <ul>
        <li parentName="ul">{`Enable latency monitoring for your endpoints`}</li>
        <li parentName="ul">{`Configure error rate alerts`}</li>
        <li parentName="ul">{`Set up uptime monitoring`}</li>
        <li parentName="ul">{`Verify log aggregation is working`}</li>
        <li parentName="ul">{`Establish an on-call rotation`}</li>
      </ul>
      <h3 {...{
        "id": "documentation"
      }}>{`Documentation`}</h3>
      <ul>
        <li parentName="ul">{`Create runbooks for common issues`}</li>
        <li parentName="ul">{`Document escalation paths`}</li>
        <li parentName="ul">{`Share support contact information with Plaid`}</li>
        <li parentName="ul">{`Define maintenance window procedures`}</li>
      </ul>
    </div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "requesting-production-access",
        level: 2,
        title: "Requesting production access",
      },
{
        id: "stealth-testing-optional",
        level: 2,
        title: "Stealth testing (optional)",
      },
{
        id: "launching-and-discoverability",
        level: 2,
        title: "Launching and discoverability",
      },
{
        id: "pre-launch-checklist",
        level: 2,
        title: "Pre-launch checklist",
      },
{
        id: "configuration",
        level: 3,
        title: "Configuration",
      },
{
        id: "testing",
        level: 3,
        title: "Testing",
      },
{
        id: "monitoring",
        level: 3,
        title: "Monitoring",
      },
{
        id: "documentation",
        level: 3,
        title: "Documentation",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
